import React from 'react'
import SupplierValidationDetailPage from "./SupplierValidationDetailPage"

function SupplierValidationDetailContainer(props) {
    const historyState = props.location.state
    const vHistoryState = Object.assign({}, historyState)
    const { currentPage = 1 , color = ''} = vHistoryState

    return (
        <div className='SupplierValidationDetailContainer'>
            <SupplierValidationDetailPage currentPage={currentPage} idValidation={props.match.params.id} color={color}/>
        </div>
    )
}

export default SupplierValidationDetailContainer
